import * as React from 'react';
import {connect} from "react-redux";
import {Redirect, Route} from 'react-router-dom';
import authState from '../../ReduxRequests/State/authState';
import {CoverNote, RecordCount} from '../../Config/dataModel';
import {URL} from '../../Config/appConfig';

interface PrivateRouteProps {
    exact: boolean,
    path: string,
    needsAuth: boolean,
    component: any,
    newRecord?: CoverNote,
    newCount?: RecordCount,
    auth?: () => object
}

class PrivateRoute extends React.Component <PrivateRouteProps, {}> {
    public render() {
        let componentExtraProps = {};
        if (this.props.newRecord) {
            componentExtraProps = {...componentExtraProps, ...{newRecord: this.props.newRecord}};
        }
        if (this.props.newCount) {
            componentExtraProps = {...componentExtraProps, ...{newCount: this.props.newCount}};
        }
        const component = <this.props.component {...componentExtraProps}/>
        return (
            <Route
                exact={this.props.exact}
                path={this.props.path}
                render={props => this.props.auth() ?
                    (this.props.needsAuth ? component : <Redirect to={URL.DASHBOARD}/>) :
                    (this.props.needsAuth ? <Redirect to={URL.LOGIN}/> : component)}
            />
        );
    }
}

export default connect(authState, null)(PrivateRoute);



// WEBPACK FOOTER //
// ./src/Components/Router/PrivateRoute.tsx